import * as React from "react";
import { Paper, Box, Typography } from "@mui/material";

export default function StatCard({ label, value, icon, color, onClick, clickable, caption }) {
  return (
    <Paper
      onClick={clickable ? onClick : undefined}
      sx={{
        p: { xs: 1.75, sm: 2 },
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
        gap: { xs: 1.5, sm: 2 },
        background: (t) =>
          t.palette.mode === "dark"
            ? "linear-gradient(180deg, rgba(255,255,255,0.04), rgba(255,255,255,0.02))"
            : "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
        border: (t) =>
          t.palette.mode === "dark"
            ? "1px solid rgba(255,255,255,0.06)"
            : "1px solid #dbe6f3",
        minHeight: { xs: 70, sm: 80 },
        cursor: clickable ? 'pointer' : 'default',
        transition: 'all 0.2s',
        '&:hover': clickable ? {
          transform: 'translateY(-2px)',
          boxShadow: 2
        } : {}
      }}
      elevation={0}
    >
      <Box
        sx={{
        width: { xs: 36, sm: 44 },
        height: { xs: 36, sm: 44 },
        borderRadius: 2,
        display: "grid",
        placeItems: "center",
        background: (t) => (t.palette.mode === "dark" ? "rgba(255,255,255,.06)" : "rgba(37,99,235,.08)"),
        flexShrink: 0,
      }}
    >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0, flex: 1, overflow: 'hidden' }}>
        <Typography 
          variant="overline" 
          color="text.secondary"
          sx={{ 
            fontSize: { xs: '0.6rem', sm: '0.75rem' },
            lineHeight: 1.3,
            display: 'block',
            wordWrap: 'break-word',
            hyphens: 'auto'
          }}
        >
          {label}
        </Typography>
        <Typography 
          variant="h5" 
          fontWeight={800} 
          sx={{ 
            lineHeight: 1.15,
            fontSize: { xs: '1.25rem', sm: '1.5rem' },
            wordBreak: 'break-word'
          }}
        >
          {value}
        </Typography>
        {caption && (
          <Typography 
            variant="caption" 
            color="text.secondary"
            sx={{ 
              fontSize: { xs: '0.65rem', sm: '0.75rem' },
              display: 'block',
              mt: 0.5
            }}
          >
            {caption}
          </Typography>
        )}
      </Box>
    </Paper>
  );
}
